import { render, staticRenderFns } from "./newMember.vue?vue&type=template&id=0c509eac&"
import script from "./newMember.vue?vue&type=script&lang=js&"
export * from "./newMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports